import React from 'react';
import { Line } from 'react-chartjs-2';

export default function LineYearComparison({ data = [], year }) {

  const labels = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];

  const mesesMap = {
    enero: 0, febrero: 1, marzo: 2, abril: 3,
    mayo: 4, junio: 5, julio: 6, agosto: 7,
    septiembre: 8, octubre: 9, noviembre: 10, diciembre: 11
  };

  const currentYear = year;
  const previousYear = year - 1;

  const currentData = new Array(12).fill(0);
  const previousData = new Array(12).fill(0);

  data.forEach(r => {
    const index = mesesMap[r.mes];

    if (index !== undefined) {
      if (r.año === currentYear) {
        currentData[index] = Number(r.total) || 0;
      }
      if (r.año === previousYear) {
        previousData[index] = Number(r.total) || 0;
      }
    }
  });

  const formatMoney = (value) =>
    new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(value);

  const chartData = {
    labels,
    datasets: [
      {
        label: `${currentYear}`,
        data: currentData,
        borderColor: '#36A2EB',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        tension: 0.4
      },
      {
        label: `${previousYear}`,
        data: previousData,
        borderColor: '#FF6384',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    interaction: {
      mode: 'index',
      intersect: false
    },

    plugins: {
      legend: {
        position: 'top'
      },
      title: {
        display: true,
        text: `Comparación ${currentYear} vs ${previousYear}`
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: ${formatMoney(ctx.raw)}`
        }
      }
    },

    scales: {
      y: {
        ticks: {
          callback: (value) => formatMoney(value)
        }
      }
    }
  };

  return (
    <div style={{ height: '350px' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}